import { Link, Outlet, useLocation } from 'react-router-dom';
import '@universityofmaryland/utilityheader';
import {useEffect, useState} from "react";
import {Menu} from "lucide-react";

export default function Layout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if we're on a mobile device
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    // Check initially
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    // Update the auth component's class when mobile menu state changes
    const authElement = document.querySelector('umd-auth');
    if (authElement) {
      if (mobileMenuOpen) {
        authElement.classList.add('menu-open');
      } else {
        authElement.classList.remove('menu-open');
      }
    }
  }, [mobileMenuOpen]);

  const isActive = (path: string) => {
    return location.pathname === path ? 'bg-gray-200' : '';
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <umd-utility-header
        size="100%"
        padding="20px"
      ></umd-utility-header>
        <>
          <nav className="bg-white shadow-sm">
            <div className="container mx-auto px-4">
              <div className="flex h-16 items-center justify-between">
                {isMobile ? (
                  // Mobile view
                  <button
                    type="button"
                    className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:bg-gray-100"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  >
                    <Menu className="h-6 w-6" />
                  </button>
                ) : (
                  // Desktop view
                  <div className="flex space-x-8">
                    <Link
                      to="/bills"
                      className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive('/bills')}`}
                    >
                      Bills
                    </Link>
                    <Link
                      to="/users"
                      className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive('/users')}`}
                    >
                      Users
                    </Link>
                    <Link
                      to="/jobs"
                      className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive('/jobs')}`}
                    >
                      Jobs
                    </Link>
                    <Link
                      to="/costs"
                      className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive('/costs')}`}
                    >
                      Costs
                    </Link>
                    <Link
                      to="/config"
                      className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive('/config')}`}
                    >
                      Config
                    </Link>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile menu dropdown */}
            {isMobile && mobileMenuOpen && (
              <div className="pt-2 pb-3 space-y-1">
                <Link
                  to="/bills"
                  className={`block px-3 py-2 text-base font-medium ${isActive('/bills')}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Bills
                </Link>
                <Link
                  to="/users"
                  className={`block px-3 py-2 text-base font-medium ${isActive('/users')}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Users
                </Link>
                <Link
                  to="/jobs"
                  className={`block px-3 py-2 text-base font-medium ${isActive('/jobs')}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Jobs
                </Link>
                <Link
                  to="/costs"
                  className={`block px-3 py-2 text-base font-medium ${isActive('/costs')}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Costs
                </Link>
                <Link
                  to="/config"
                  className={`block px-3 py-2 text-base font-medium ${isActive('/config')}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Config
                </Link>
              </div>
            )}
          </nav>

          <main className="py-6">
            <div className="container mx-auto px-4">
              <Outlet />
            </div>
          </main>
        </>
    </div>
  );
}